import React from 'react';
import Svg, { Path } from 'react-native-svg';

type ChevronRightIconProps = {
  size?: number;
  color?: string;
};

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({ size = 24, color = '#333' }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"
        fill={color}
      />
    </Svg>
  );
};

export default ChevronRightIcon;
